import { Injectable } from '@angular/core';

/**
 * Class representing the localization config
 */
@Injectable()
export class LocalizationServiceConfig {
  public locale_id: string = '';
}